import { Box, Button, CircularProgress, Divider, Stack } from '@mui/material'
import { FC, Fragment } from 'react'
import { Trans } from 'react-i18next'
import { useRepliesQuery } from '~/features/video_detail/hooks/replies/useRepliesQuery'
import ReplyRow from '../reply/ReplyRow'

const RepliesList: FC<{ videoId: string; commentId: string }> = ({ commentId, videoId }) => {
  const {
    query: { data, error, loading },
    loadMore,
  } = useRepliesQuery(videoId, commentId)
  return (
    <Stack paddingLeft={4}>
      {loading ? (
        <Box display='flex' justifyContent='center' padding={2}>
          <CircularProgress />
        </Box>
      ) : !!error ? (
        <></>
      ) : (
        <>
          {data?.commentReplies?.edges?.map((edge, idx) => (
            <Fragment key={idx}>
              {idx == 0 && <Divider />}
              <Box marginTop={2}>
                <ReplyRow videoId={videoId} reply={edge.node!} />
                {idx < (data?.commentReplies.edges?.length ?? 0) - 1 && <Divider />}
              </Box>
            </Fragment>
          ))}
          {data?.commentReplies.pageInfo?.hasNextPage == true && (
            <Button onClick={loadMore}>
              <Trans i18nKey='view_more' />
            </Button>
          )}
        </>
      )}
    </Stack>
  )
}

export default RepliesList
